<template>
  <div class="modal-overlay" @click.self="closeModal">
    <div class="modal-container">
      <div class="modal-header">
        <h2>{{ isEditing ? 'Modifier le Shift' : 'Ajouter un Shift' }}</h2>
        <button class="close-btn" @click="closeModal">
          <span class="material-icons">close</span>
        </button>
      </div>
      
      <form @submit.prevent="saveShift" class="shift-form">
        <div class="form-row">
          <div class="form-group half-width">
            <label for="code">Code<span class="required">*</span></label>
            <div class="input-with-icon">
              <span class="material-icons input-icon">code</span>
              <input 
                type="text" 
                id="code" 
                v-model="formData.code" 
                required 
                :class="{ 'error': formErrors.code }"
                placeholder="Ex: MAT"
                maxlength="5"
              />
            </div>
            <span class="error-message" v-if="formErrors.code">{{ formErrors.code }}</span>
          </div>
          
          <div class="form-group half-width">
            <label for="name">Nom<span class="required">*</span></label>
            <div class="input-with-icon">
              <span class="material-icons input-icon">label</span>
              <input 
                type="text" 
                id="name" 
                v-model="formData.name" 
                required 
                :class="{ 'error': formErrors.name }"
                placeholder="Ex: Matinée"
              />
            </div>
            <span class="error-message" v-if="formErrors.name">{{ formErrors.name }}</span>
          </div>
        </div>
        
        <div class="form-group">
          <label for="description">Description</label>
          <div class="input-with-icon">
            <span class="material-icons input-icon">description</span>
            <textarea 
              id="description" 
              v-model="formData.description" 
              :class="{ 'error': formErrors.description }"
              placeholder="Description du shift"
              rows="2"
            ></textarea>
          </div>
          <span class="error-message" v-if="formErrors.description">{{ formErrors.description }}</span>
        </div>
        
        <div class="form-row">
          <div class="form-group half-width">
            <label for="heure_debut">Heure de début<span class="required">*</span></label>
            <div class="input-with-icon">
              <span class="material-icons input-icon">schedule</span>
              <input 
                type="time" 
                id="heure_debut" 
                v-model="formData.heure_debut" 
                required 
                :class="{ 'error': formErrors.heure_debut }"
              />
            </div>
            <span class="error-message" v-if="formErrors.heure_debut">{{ formErrors.heure_debut }}</span>
          </div>
          
          <div class="form-group half-width">
            <label for="heure_fin">Heure de fin<span class="required">*</span></label>
            <div class="input-with-icon">
              <span class="material-icons input-icon">schedule</span>
              <input 
                type="time" 
                id="heure_fin" 
                v-model="formData.heure_fin" 
                required 
                :class="{ 'error': formErrors.heure_fin }"
              />
            </div>
            <span class="error-message" v-if="formErrors.heure_fin">{{ formErrors.heure_fin }}</span>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group half-width">
            <label for="pause_debut">Début de pause</label>
            <div class="input-with-icon">
              <span class="material-icons input-icon">free_breakfast</span>
              <input 
                type="time" 
                id="pause_debut" 
                v-model="formData.pause_debut" 
                :class="{ 'error': formErrors.pause_debut }"
              />
            </div>
            <span class="error-message" v-if="formErrors.pause_debut">{{ formErrors.pause_debut }}</span>
          </div>
          
          <div class="form-group half-width">
            <label for="pause_fin">Fin de pause</label>
            <div class="input-with-icon">
              <span class="material-icons input-icon">free_breakfast</span>
              <input 
                type="time" 
                id="pause_fin" 
                v-model="formData.pause_fin" 
                :class="{ 'error': formErrors.pause_fin }"
              />
            </div>
            <span class="error-message" v-if="formErrors.pause_fin">{{ formErrors.pause_fin }}</span>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group half-width">
            <label for="tolerance_retard">Tolérance de retard (minutes)<span class="required">*</span></label>
            <div class="input-with-icon">
              <span class="material-icons input-icon">timer</span>
              <input 
                type="number" 
                id="tolerance_retard" 
                v-model="formData.tolerance_retard" 
                required 
                min="0"
                max="60"
                :class="{ 'error': formErrors.tolerance_retard }"
              />
            </div>
            <span class="error-message" v-if="formErrors.tolerance_retard">{{ formErrors.tolerance_retard }}</span>
          </div>
          
          <div class="form-group half-width">
            <label for="coefficient">Coefficient</label>
            <div class="input-with-icon">
              <span class="material-icons input-icon">calculate</span>
              <input 
                type="number" 
                id="coefficient" 
                v-model="formData.coefficient" 
                step="0.1"
                min="0.1"
                :class="{ 'error': formErrors.coefficient }"
              />
            </div>
            <span class="error-message" v-if="formErrors.coefficient">{{ formErrors.coefficient }}</span>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group half-width">
            <label for="color">Couleur</label>
            <div class="color-picker">
              <input 
                type="color" 
                id="color" 
                v-model="formData.color" 
                :class="{ 'error': formErrors.color }"
              />
              <span class="color-preview" :style="{ backgroundColor: formData.color }"></span>
            </div>
            <span class="error-message" v-if="formErrors.color">{{ formErrors.color }}</span>
          </div>
          
          <div class="form-group half-width checkbox-group">
            <div class="checkbox-container">
              <input 
                type="checkbox" 
                id="active" 
                v-model="formData.active"
                class="styled-checkbox"
              />
              <span class="checkmark"></span>
              <label for="active">Actif</label>
            </div>
          </div>
        </div>
        
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" @click="closeModal">Annuler</button>
          <button type="submit" class="btn btn-primary">{{ isEditing ? 'Mettre à jour' : 'Ajouter' }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import api from '@/services/api';

const props = defineProps({
  shift: {
    type: Object,
    default: null
  },
  isOpen: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'save']);

const isEditing = computed(() => !!props.shift);

const formData = reactive({
  code: '',
  name: '',
  description: '',
  heure_debut: '08:00',
  heure_fin: '17:00',
  pause_debut: '',
  pause_fin: '',
  tolerance_retard: 15,
  coefficient: 1.0,
  color: '#4A90E2',
  active: true
});

const formErrors = reactive({
  code: '',
  name: '',
  description: '',
  heure_debut: '',
  heure_fin: '',
  pause_debut: '',
  pause_fin: '',
  tolerance_retard: '',
  coefficient: '',
  color: ''
});

const resetForm = () => {
  Object.keys(formData).forEach(key => {
    if (key === 'tolerance_retard') formData[key] = 15;
    else if (key === 'coefficient') formData[key] = 1.0;
    else if (key === 'color') formData[key] = '#4A90E2';
    else if (key === 'active') formData[key] = true;
    else if (key === 'heure_debut') formData[key] = '08:00';
    else if (key === 'heure_fin') formData[key] = '17:00';
    else formData[key] = '';
  });
  
  Object.keys(formErrors).forEach(key => {
    formErrors[key] = '';
  });
};

const initForm = () => {
  if (props.shift) {
    Object.keys(formData).forEach(key => {
      if (props.shift[key] !== undefined) {
        formData[key] = props.shift[key];
      }
    });
  } else {
    resetForm();
  }
};

const validateForm = () => {
  let isValid = true;
  
  // Réinitialiser les erreurs
  Object.keys(formErrors).forEach(key => {
    formErrors[key] = '';
  });
  
  // Valider le code
  if (!formData.code.trim()) {
    formErrors.code = 'Le code est requis';
    isValid = false;
  } else if (formData.code.length > 5) {
    formErrors.code = 'Le code ne doit pas dépasser 5 caractères';
    isValid = false;
  }
  
  // Valider le nom
  if (!formData.name.trim()) {
    formErrors.name = 'Le nom est requis';
    isValid = false;
  }
  
  // Valider les heures
  if (!formData.heure_debut) {
    formErrors.heure_debut = 'L\'heure de début est requise';
    isValid = false;
  }
  
  if (!formData.heure_fin) {
    formErrors.heure_fin = 'L\'heure de fin est requise';
    isValid = false;
  }
  
  // Valider que l'heure de fin est après l'heure de début
  if (formData.heure_debut && formData.heure_fin) {
    const debut = new Date(`2000-01-01T${formData.heure_debut}`);
    const fin = new Date(`2000-01-01T${formData.heure_fin}`);
    
    if (fin <= debut) {
      formErrors.heure_fin = 'L\'heure de fin doit être après l\'heure de début';
      isValid = false;
    }
  }
  
  // Valider les pauses si elles sont définies
  if (formData.pause_debut && !formData.pause_fin) {
    formErrors.pause_fin = 'La fin de pause est requise si le début est défini';
    isValid = false;
  }
  
  if (!formData.pause_debut && formData.pause_fin) {
    formErrors.pause_debut = 'Le début de pause est requis si la fin est définie';
    isValid = false;
  }
  
  // Valider que la pause est dans les heures du shift
  if (formData.pause_debut && formData.pause_fin && formData.heure_debut && formData.heure_fin) {
    const debut = new Date(`2000-01-01T${formData.heure_debut}`);
    const fin = new Date(`2000-01-01T${formData.heure_fin}`);
    const pauseDebut = new Date(`2000-01-01T${formData.pause_debut}`);
    const pauseFin = new Date(`2000-01-01T${formData.pause_fin}`);
    
    if (pauseDebut < debut || pauseDebut > fin) {
      formErrors.pause_debut = 'Le début de pause doit être dans les heures du shift';
      isValid = false;
    }
    
    if (pauseFin < debut || pauseFin > fin) {
      formErrors.pause_fin = 'La fin de pause doit être dans les heures du shift';
      isValid = false;
    }
    
    if (pauseFin <= pauseDebut) {
      formErrors.pause_fin = 'La fin de pause doit être après le début';
      isValid = false;
    }
  }
  
  // Valider la tolérance de retard
  if (formData.tolerance_retard === '' || formData.tolerance_retard === null) {
    formErrors.tolerance_retard = 'La tolérance de retard est requise';
    isValid = false;
  } else if (formData.tolerance_retard < 0 || formData.tolerance_retard > 60) {
    formErrors.tolerance_retard = 'La tolérance doit être entre 0 et 60 minutes';
    isValid = false;
  }
  
  // Valider le coefficient
  if (formData.coefficient === '' || formData.coefficient === null) {
    formData.coefficient = 1.0; // Valeur par défaut
  } else if (formData.coefficient < 0.1) {
    formErrors.coefficient = 'Le coefficient doit être supérieur à 0.1';
    isValid = false;
  }
  
  return isValid;
};

const saveShift = async () => {
  if (!validateForm()) {
    return;
  }
  
  try {
    let response;
    
    if (isEditing.value) {
      response = await api.updateShift(props.shift.id, formData);
    } else {
      response = await api.createShift(formData);
    }
    
    if (response.data.success) {
      emit('save', response.data.data);
      closeModal();
    } else {
      // Gérer les erreurs de validation côté serveur
      if (response.data.error && response.data.error.details) {
        const errors = response.data.error.details;
        Object.keys(errors).forEach(key => {
          if (formErrors[key] !== undefined) {
            formErrors[key] = errors[key];
          }
        });
      }
    }
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement du shift:', error);
    // Afficher un message d'erreur général
  }
};

const closeModal = () => {
  emit('close');
};

onMounted(() => {
  initForm();
});

// Réinitialiser le formulaire quand le shift change
watch(
  () => props.shift,
  () => {
    initForm();
  }
);

// Réinitialiser le formulaire quand la modal s'ouvre
watch(
  () => props.isOpen,
  (newVal) => {
    if (newVal) {
      initForm();
    }
  }
);
</script>

<style scoped>
/* Import des variables de couleurs OpSolver */
@import '@/assets/css/variables.css';

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(to right, var(--turquoise-deep, #155751), var(--turquoise-primary, #30C7B5));
  color: white;
}

.modal-header h2 {
  margin: 0;
  color: white;
  font-size: 1.25rem;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}

.shift-form {
  padding: 24px;
}

.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.form-group {
  margin-bottom: 16px;
  width: 100%;
}

.half-width {
  width: calc(50% - 8px);
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #374151;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.input-with-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--turquoise-primary, #30C7B5);
  font-size: 1.25rem;
  opacity: 0.7;
}

input[type="text"],
input[type="number"],
input[type="time"],
textarea,
select {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

textarea {
  resize: vertical;
  min-height: 80px;
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: var(--turquoise-primary, #30C7B5);
  box-shadow: 0 0 0 3px rgba(48, 199, 181, 0.2);
}

.error {
  border-color: #ef4444 !important;
}

.error-message {
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.color-picker {
  display: flex;
  align-items: center;
  gap: 12px;
}

input[type="color"] {
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.color-preview {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
}

.checkbox-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
}

.styled-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.btn-primary {
  background-color: var(--turquoise-primary, #30C7B5);
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: var(--turquoise-dark, #26A194);
}

.btn-secondary {
  background-color: white;
  color: #374151;
  border: 1px solid #d1d5db;
}

.btn-secondary:hover {
  background-color: #f3f4f6;
}
</style>
